import {
  B_07,
  BANNER_DEFAULTS,
  hideB07Props,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const B07_PLASMIC_PROPS = {
  b07Eyebrow: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_07].eyebrow,
    description: "Eyebrow text (B07 only)",
    hidden: hideB07Props,
  },
  b07Heading: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_07].heading,
    description: "Main heading (B07 only)",
    hidden: hideB07Props,
  },
  b07Subtext: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_07].subtext,
    description: "Subtext below heading (B07 only)",
    hidden: hideB07Props,
  },
  b07InputPlaceholder: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_07].inputPlaceholder,
    description: "Email input placeholder text (B07 only)",
    hidden: hideB07Props,
  },
  b07MobileImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_07].mobileImg,
    description: "Mobile/tablet background image (B07 only)",
    hidden: hideB07Props,
  },
  b07DesktopImg: {
    type: "imageUrl",
    defaultValue: BANNER_DEFAULTS[B_07].desktopImg,
    description: "Desktop background image (B07 only)",
    hidden: hideB07Props,
  },
  b07ImageAlt: {
    type: "string",
    defaultValue: BANNER_DEFAULTS[B_07].imageAlt,
    description: "Image alt text (B07 only)",
    hidden: hideB07Props,
  },
  b07OverlayOpacity: {
    type: "number",
    defaultValue: BANNER_DEFAULTS[B_07].overlayOpacity,
    description: "Overlay opacity (0-1) (B07 only)",
    hidden: hideB07Props,
  },
};
